import React from "react";
import { store } from "Helpers/LocalStorage";
import * as Icons from "react-bootstrap-icons";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { TRANSFER } from "Stores/actionTypes";

export default function DashboardExiter({ visible }) {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const onCLick = (e) => {
    e.preventDefault();
    store("StypeSwAllow", false);
    dispatch({ type: TRANSFER, transfer: false });
    window.close();
  };

  return (
    <>
      {visible && window.location.pathname.split("/")[1] === "dashboard" && (
        <div className="exit-dashboard" onClick={onCLick}>
          <Icons.DoorClosedFill size={23} />
          <span>{t("disabledTransport")}</span>
        </div>
      )}
    </>
  );
}
